import request, { ACCEPT_HEADER_V2 } from '@utils/request';
import { Property } from 'shared-types/Property';
import { AnnouncementSchema } from './schemas';
import { PaginatedResponse } from '@common/features/state';

export async function getAnnouncements(slug: Property['slug']) {
  const { data } = await request.base.get(`store/marketing/site/${slug}/announcements`, {
    headers: {
      Accept: ACCEPT_HEADER_V2,
    },
  });

  return PaginatedResponse(AnnouncementSchema).parse(data);
}
